/**
 * Converts a legacy IStyle rule into CSS properties
 * that can be used for inline styles
 */
export const convertToCssObject = (rule: Object) => {
  if (rule === undefined) return {};

  const cssObj: { [key: string]: any } = {};
  for (const [property, value] of Object.entries(rule)) {
    // skip selectors/nested styles
    if (property === "selectors") continue;

    if (typeof value === "number") {
      cssObj[property] = `${value}px`;
    } else {
      cssObj[property] = value;
    }
  }
  return cssObj as React.CSSProperties;
};
